import "./main.css";
import $lbkGW$spectrumiconsuiAlertSmall from "@spectrum-icons/ui/AlertSmall";
import {useStyleProps as $lbkGW$useStyleProps, createDOMRef as $lbkGW$createDOMRef, classNames as $lbkGW$classNames} from "@react-spectrum/utils";
import $lbkGW$spectrumiconsuiInfoSmall from "@spectrum-icons/ui/InfoSmall";
import {mergeProps as $lbkGW$mergeProps, useLayoutEffect as $lbkGW$useLayoutEffect} from "@react-aria/utils";
import $lbkGW$react, {useContext as $lbkGW$useContext, useRef as $lbkGW$useRef, useImperativeHandle as $lbkGW$useImperativeHandle, useState as $lbkGW$useState} from "react";
import $lbkGW$spectrumiconsuiSuccessSmall from "@spectrum-icons/ui/SuccessSmall";
import {useTooltip as $lbkGW$useTooltip, useTooltipTrigger as $lbkGW$useTooltipTrigger} from "@react-aria/tooltip";
import {FocusableProvider as $lbkGW$FocusableProvider} from "@react-aria/focus";
import {Overlay as $lbkGW$Overlay} from "@react-spectrum/overlays";
import {useOverlayPosition as $lbkGW$useOverlayPosition} from "@react-aria/overlays";
import {useTooltipTriggerState as $lbkGW$useTooltipTriggerState} from "@react-stately/tooltip";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




var $1e9110aec8886b85$exports = {};

$parcel$export($1e9110aec8886b85$exports, "focus-ring", () => $1e9110aec8886b85$export$f39a09f249340e2a, (v) => $1e9110aec8886b85$export$f39a09f249340e2a = v);
$parcel$export($1e9110aec8886b85$exports, "i18nFontFamily", () => $1e9110aec8886b85$export$8c4ee2c50c22c514, (v) => $1e9110aec8886b85$export$8c4ee2c50c22c514 = v);
$parcel$export($1e9110aec8886b85$exports, "is-focused", () => $1e9110aec8886b85$export$e7dc768d35940237, (v) => $1e9110aec8886b85$export$e7dc768d35940237 = v);
$parcel$export($1e9110aec8886b85$exports, "is-hovered", () => $1e9110aec8886b85$export$b8813cd5d7824ce7, (v) => $1e9110aec8886b85$export$b8813cd5d7824ce7 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay--open", () => $1e9110aec8886b85$export$a397eb58038aa381, (v) => $1e9110aec8886b85$export$a397eb58038aa381 = v);
$parcel$export($1e9110aec8886b85$exports, "is-open", () => $1e9110aec8886b85$export$a9781837241c946d, (v) => $1e9110aec8886b85$export$a9781837241c946d = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay--bottom--open", () => $1e9110aec8886b85$export$a96755f239de61ee, (v) => $1e9110aec8886b85$export$a96755f239de61ee = v);
$parcel$export($1e9110aec8886b85$exports, "is-open--bottom", () => $1e9110aec8886b85$export$1f160596ffe52357, (v) => $1e9110aec8886b85$export$1f160596ffe52357 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay--left--open", () => $1e9110aec8886b85$export$a85c0c6b6cf8598c, (v) => $1e9110aec8886b85$export$a85c0c6b6cf8598c = v);
$parcel$export($1e9110aec8886b85$exports, "is-open--left", () => $1e9110aec8886b85$export$d6106cb3acaf56ae, (v) => $1e9110aec8886b85$export$d6106cb3acaf56ae = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay--right--open", () => $1e9110aec8886b85$export$85aaa87e65e040bf, (v) => $1e9110aec8886b85$export$85aaa87e65e040bf = v);
$parcel$export($1e9110aec8886b85$exports, "is-open--right", () => $1e9110aec8886b85$export$8935d072812c3169, (v) => $1e9110aec8886b85$export$8935d072812c3169 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay--top--open", () => $1e9110aec8886b85$export$b9768db7ffc1bc2, (v) => $1e9110aec8886b85$export$b9768db7ffc1bc2 = v);
$parcel$export($1e9110aec8886b85$exports, "is-open--top", () => $1e9110aec8886b85$export$cd4bf1e07ae86214, (v) => $1e9110aec8886b85$export$cd4bf1e07ae86214 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-FocusRing-ring", () => $1e9110aec8886b85$export$4109102f950813a6, (v) => $1e9110aec8886b85$export$4109102f950813a6 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-FocusRing", () => $1e9110aec8886b85$export$24c7f46a6e3605dd, (v) => $1e9110aec8886b85$export$24c7f46a6e3605dd = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-FocusRing--quiet", () => $1e9110aec8886b85$export$2927016961429360, (v) => $1e9110aec8886b85$export$2927016961429360 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-overlay", () => $1e9110aec8886b85$export$39eed38e2296a1d6, (v) => $1e9110aec8886b85$export$39eed38e2296a1d6 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip", () => $1e9110aec8886b85$export$f7bf7078d3d03f05, (v) => $1e9110aec8886b85$export$f7bf7078d3d03f05 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--bottom", () => $1e9110aec8886b85$export$4f420a9bbb442953, (v) => $1e9110aec8886b85$export$4f420a9bbb442953 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--error", () => $1e9110aec8886b85$export$2b291890a5577893, (v) => $1e9110aec8886b85$export$2b291890a5577893 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--help", () => $1e9110aec8886b85$export$d33ca445ae528241, (v) => $1e9110aec8886b85$export$d33ca445ae528241 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--info", () => $1e9110aec8886b85$export$e995d5780591d0a8, (v) => $1e9110aec8886b85$export$e995d5780591d0a8 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--left", () => $1e9110aec8886b85$export$47f060b68b4cab2c, (v) => $1e9110aec8886b85$export$47f060b68b4cab2c = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--negative", () => $1e9110aec8886b85$export$92fe45b4260594f6, (v) => $1e9110aec8886b85$export$92fe45b4260594f6 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--positive", () => $1e9110aec8886b85$export$11cbf31e1b6e51ac, (v) => $1e9110aec8886b85$export$11cbf31e1b6e51ac = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--right", () => $1e9110aec8886b85$export$c094187772823b2e, (v) => $1e9110aec8886b85$export$c094187772823b2e = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--success", () => $1e9110aec8886b85$export$4eae622bc9b08cac, (v) => $1e9110aec8886b85$export$4eae622bc9b08cac = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip--top", () => $1e9110aec8886b85$export$d7516df59e198fc7, (v) => $1e9110aec8886b85$export$d7516df59e198fc7 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip-label", () => $1e9110aec8886b85$export$f4096e0dc445b255, (v) => $1e9110aec8886b85$export$f4096e0dc445b255 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip-tip", () => $1e9110aec8886b85$export$9deb89a7a91de30, (v) => $1e9110aec8886b85$export$9deb89a7a91de30 = v);
$parcel$export($1e9110aec8886b85$exports, "spectrum-Tooltip-typeIcon", () => $1e9110aec8886b85$export$ff23d46fee8272e4, (v) => $1e9110aec8886b85$export$ff23d46fee8272e4 = v);
$parcel$export($1e9110aec8886b85$exports, "u-tooltip-showOnHover", () => $1e9110aec8886b85$export$6ea3237f62800d00, (v) => $1e9110aec8886b85$export$6ea3237f62800d00 = v);
var $1e9110aec8886b85$export$f39a09f249340e2a;
var $1e9110aec8886b85$export$8c4ee2c50c22c514;
var $1e9110aec8886b85$export$e7dc768d35940237;
var $1e9110aec8886b85$export$b8813cd5d7824ce7;
var $1e9110aec8886b85$export$a397eb58038aa381;
var $1e9110aec8886b85$export$a9781837241c946d;
var $1e9110aec8886b85$export$a96755f239de61ee;
var $1e9110aec8886b85$export$1f160596ffe52357;
var $1e9110aec8886b85$export$a85c0c6b6cf8598c;
var $1e9110aec8886b85$export$d6106cb3acaf56ae;
var $1e9110aec8886b85$export$85aaa87e65e040bf;
var $1e9110aec8886b85$export$8935d072812c3169;
var $1e9110aec8886b85$export$b9768db7ffc1bc2;
var $1e9110aec8886b85$export$cd4bf1e07ae86214;
var $1e9110aec8886b85$export$4109102f950813a6;
var $1e9110aec8886b85$export$24c7f46a6e3605dd;
var $1e9110aec8886b85$export$2927016961429360;
var $1e9110aec8886b85$export$39eed38e2296a1d6;
var $1e9110aec8886b85$export$f7bf7078d3d03f05;
var $1e9110aec8886b85$export$4f420a9bbb442953;
var $1e9110aec8886b85$export$2b291890a5577893;
var $1e9110aec8886b85$export$d33ca445ae528241;
var $1e9110aec8886b85$export$e995d5780591d0a8;
var $1e9110aec8886b85$export$47f060b68b4cab2c;
var $1e9110aec8886b85$export$92fe45b4260594f6;
var $1e9110aec8886b85$export$11cbf31e1b6e51ac;
var $1e9110aec8886b85$export$c094187772823b2e;
var $1e9110aec8886b85$export$4eae622bc9b08cac;
var $1e9110aec8886b85$export$d7516df59e198fc7;
var $1e9110aec8886b85$export$f4096e0dc445b255;
var $1e9110aec8886b85$export$9deb89a7a91de30;
var $1e9110aec8886b85$export$ff23d46fee8272e4;
var $1e9110aec8886b85$export$6ea3237f62800d00;
$1e9110aec8886b85$export$f39a09f249340e2a = `KF3Kcq_focus-ring`;
$1e9110aec8886b85$export$8c4ee2c50c22c514 = `KF3Kcq_i18nFontFamily`;
$1e9110aec8886b85$export$e7dc768d35940237 = `KF3Kcq_is-focused`;
$1e9110aec8886b85$export$b8813cd5d7824ce7 = `KF3Kcq_is-hovered`;
$1e9110aec8886b85$export$a397eb58038aa381 = `KF3Kcq_spectrum-overlay--open`;
$1e9110aec8886b85$export$a9781837241c946d = `KF3Kcq_is-open ${$1e9110aec8886b85$export$a397eb58038aa381}`;
$1e9110aec8886b85$export$a96755f239de61ee = `KF3Kcq_spectrum-overlay--bottom--open`;
$1e9110aec8886b85$export$1f160596ffe52357 = `KF3Kcq_is-open--bottom ${$1e9110aec8886b85$export$a96755f239de61ee}`;
$1e9110aec8886b85$export$a85c0c6b6cf8598c = `KF3Kcq_spectrum-overlay--left--open`;
$1e9110aec8886b85$export$d6106cb3acaf56ae = `KF3Kcq_is-open--left ${$1e9110aec8886b85$export$a85c0c6b6cf8598c}`;
$1e9110aec8886b85$export$85aaa87e65e040bf = `KF3Kcq_spectrum-overlay--right--open`;
$1e9110aec8886b85$export$8935d072812c3169 = `KF3Kcq_is-open--right ${$1e9110aec8886b85$export$85aaa87e65e040bf}`;
$1e9110aec8886b85$export$b9768db7ffc1bc2 = `KF3Kcq_spectrum-overlay--top--open`;
$1e9110aec8886b85$export$cd4bf1e07ae86214 = `KF3Kcq_is-open--top ${$1e9110aec8886b85$export$b9768db7ffc1bc2}`;
$1e9110aec8886b85$export$4109102f950813a6 = `KF3Kcq_spectrum-FocusRing-ring`;
$1e9110aec8886b85$export$24c7f46a6e3605dd = `KF3Kcq_spectrum-FocusRing ${$1e9110aec8886b85$export$4109102f950813a6}`;
$1e9110aec8886b85$export$2927016961429360 = `KF3Kcq_spectrum-FocusRing--quiet`;
$1e9110aec8886b85$export$39eed38e2296a1d6 = `KF3Kcq_spectrum-overlay`;
$1e9110aec8886b85$export$f7bf7078d3d03f05 = `KF3Kcq_spectrum-Tooltip ${$1e9110aec8886b85$export$39eed38e2296a1d6}`;
$1e9110aec8886b85$export$4f420a9bbb442953 = `KF3Kcq_spectrum-Tooltip--bottom`;
$1e9110aec8886b85$export$2b291890a5577893 = `KF3Kcq_spectrum-Tooltip--error`;
$1e9110aec8886b85$export$d33ca445ae528241 = `KF3Kcq_spectrum-Tooltip--help`;
$1e9110aec8886b85$export$e995d5780591d0a8 = `KF3Kcq_spectrum-Tooltip--info`;
$1e9110aec8886b85$export$47f060b68b4cab2c = `KF3Kcq_spectrum-Tooltip--left`;
$1e9110aec8886b85$export$92fe45b4260594f6 = `KF3Kcq_spectrum-Tooltip--negative`;
$1e9110aec8886b85$export$11cbf31e1b6e51ac = `KF3Kcq_spectrum-Tooltip--positive`;
$1e9110aec8886b85$export$c094187772823b2e = `KF3Kcq_spectrum-Tooltip--right`;
$1e9110aec8886b85$export$4eae622bc9b08cac = `KF3Kcq_spectrum-Tooltip--success`;
$1e9110aec8886b85$export$d7516df59e198fc7 = `KF3Kcq_spectrum-Tooltip--top`;
$1e9110aec8886b85$export$f4096e0dc445b255 = `KF3Kcq_spectrum-Tooltip-label`;
$1e9110aec8886b85$export$9deb89a7a91de30 = `KF3Kcq_spectrum-Tooltip-tip`;
$1e9110aec8886b85$export$ff23d46fee8272e4 = `KF3Kcq_spectrum-Tooltip-typeIcon`;
$1e9110aec8886b85$export$6ea3237f62800d00 = `KF3Kcq_u-tooltip-showOnHover`;



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $b8c00169fae46ac7$export$39ae08fa83328b12 = (0, $lbkGW$react).createContext({});



let $dc9e2a6f9971fb04$var$iconMap = {
    info: (0, $lbkGW$spectrumiconsuiInfoSmall),
    positive: (0, $lbkGW$spectrumiconsuiSuccessSmall),
    negative: (0, $lbkGW$spectrumiconsuiAlertSmall)
};
function $dc9e2a6f9971fb04$var$Tooltip(props, ref) {
    let { ref: overlayRef, arrowProps: arrowProps, state: state, arrowRef: arrowRef, ...tooltipProviderProps } = (0, $lbkGW$useContext)((0, $b8c00169fae46ac7$export$39ae08fa83328b12));
    let defaultRef = (0, $lbkGW$useRef)();
    overlayRef = overlayRef || defaultRef;
    props = (0, $lbkGW$mergeProps)(props, tooltipProviderProps);
    let { variant: variant = "neutral", placement: placement = "top", isOpen: isOpen, showIcon: showIcon, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $lbkGW$useStyleProps)(otherProps);
    let { tooltipProps: tooltipProps } = (0, $lbkGW$useTooltip)(props, state);
    // Sync ref with overlayRef from context.
    (0, $lbkGW$useImperativeHandle)(ref, ()=>(0, $lbkGW$createDOMRef)(overlayRef));
    let Icon = $dc9e2a6f9971fb04$var$iconMap[variant];
    return /*#__PURE__*/ (0, $lbkGW$react).createElement("div", {
        ...styleProps,
        ...tooltipProps,
        className: (0, $lbkGW$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($1e9110aec8886b85$exports))), "spectrum-Tooltip", `spectrum-Tooltip--${variant}`, `spectrum-Tooltip--${placement}`, {
            "is-open": isOpen,
            [`is-open--${placement}`]: isOpen
        }, styleProps.className),
        ref: overlayRef
    }, showIcon && variant !== "neutral" && /*#__PURE__*/ (0, $lbkGW$react).createElement(Icon, {
        UNSAFE_className: (0, $lbkGW$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($1e9110aec8886b85$exports))), "spectrum-Tooltip-typeIcon"),
        "aria-hidden": true
    }), props.children && /*#__PURE__*/ (0, $lbkGW$react).createElement("span", {
        className: (0, $lbkGW$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($1e9110aec8886b85$exports))), "spectrum-Tooltip-label")
    }, props.children), /*#__PURE__*/ (0, $lbkGW$react).createElement("span", {
        ...arrowProps,
        ref: arrowRef,
        className: (0, $lbkGW$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($1e9110aec8886b85$exports))), "spectrum-Tooltip-tip")
    }));
}
/**
 * Display container for Tooltip content. Has a directional arrow dependent on its placement.
 */ let $dc9e2a6f9971fb04$export$28c660c63b792dea = /*#__PURE__*/ (0, $lbkGW$react).forwardRef($dc9e2a6f9971fb04$var$Tooltip);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







const $019364e6919ef1db$var$DEFAULT_OFFSET = -1; // Offset needed to reach 4px/5px (med/large) distance between tooltip and trigger button
const $019364e6919ef1db$var$DEFAULT_CROSS_OFFSET = 0;
function $019364e6919ef1db$var$TooltipTrigger(props) {
    let { children: children, crossOffset: crossOffset = $019364e6919ef1db$var$DEFAULT_CROSS_OFFSET, isDisabled: isDisabled, offset: offset = $019364e6919ef1db$var$DEFAULT_OFFSET, trigger: triggerAction } = props;
    let [trigger, tooltip] = (0, $lbkGW$react).Children.toArray(children);
    let state = (0, $lbkGW$useTooltipTriggerState)(props);
    let tooltipTriggerRef = (0, $lbkGW$useRef)();
    let overlayRef = (0, $lbkGW$useRef)();
    let { triggerProps: triggerProps, tooltipProps: tooltipProps } = (0, $lbkGW$useTooltipTrigger)({
        isDisabled: isDisabled,
        trigger: triggerAction
    }, state, tooltipTriggerRef);
    let [borderRadius, setBorderRadius] = (0, $lbkGW$useState)(0);
    (0, $lbkGW$useLayoutEffect)(()=>{
        if (overlayRef.current && state.isOpen) {
            let spectrumBorderRadius = window.getComputedStyle(overlayRef.current).borderRadius;
            if (spectrumBorderRadius !== "") setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        state.isOpen,
        overlayRef
    ]);
    let arrowRef = (0, $lbkGW$useRef)(null);
    let [arrowWidth, setArrowWidth] = (0, $lbkGW$useState)(0);
    (0, $lbkGW$useLayoutEffect)(()=>{
        if (arrowRef.current && state.isOpen) setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }, [
        state.isOpen,
        arrowRef
    ]);
    let { overlayProps: overlayProps, arrowProps: arrowProps, placement: placement } = (0, $lbkGW$useOverlayPosition)({
        placement: props.placement || "top",
        targetRef: tooltipTriggerRef,
        overlayRef: overlayRef,
        offset: offset,
        crossOffset: crossOffset,
        isOpen: state.isOpen,
        shouldFlip: props.shouldFlip,
        containerPadding: props.containerPadding,
        arrowSize: arrowWidth,
        arrowBoundaryOffset: borderRadius
    });
    return /*#__PURE__*/ (0, $lbkGW$react).createElement((0, $lbkGW$FocusableProvider), {
        ...triggerProps,
        ref: tooltipTriggerRef
    }, trigger, /*#__PURE__*/ (0, $lbkGW$react).createElement((0, $b8c00169fae46ac7$export$39ae08fa83328b12).Provider, {
        value: {
            state: state,
            placement: placement,
            ref: overlayRef,
            UNSAFE_style: overlayProps.style,
            arrowProps: arrowProps,
            arrowRef: arrowRef,
            ...tooltipProps
        }
    }, /*#__PURE__*/ (0, $lbkGW$react).createElement((0, $lbkGW$Overlay), {
        isOpen: state.isOpen,
        nodeRef: overlayRef
    }, tooltip)));
}
// Support TooltipTrigger inside components using CollectionBuilder.
$019364e6919ef1db$var$TooltipTrigger.getCollectionNode = function*(props) {
    // Replaced the use of React.Childern.toArray because it mutates the key prop.
    let childArray = [];
    (0, $lbkGW$react).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, $lbkGW$react).isValidElement(child)) childArray.push(child);
    });
    let [trigger, tooltip] = childArray;
    yield {
        element: trigger,
        wrapper: (element)=>/*#__PURE__*/ (0, $lbkGW$react).createElement($019364e6919ef1db$var$TooltipTrigger, {
                key: element.key,
                ...props
            }, element, tooltip)
    };
};
/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */ // We don't want getCollectionNode to show up in the type definition
let $019364e6919ef1db$export$8c610744efcf8a1d = $019364e6919ef1db$var$TooltipTrigger;




export {$dc9e2a6f9971fb04$export$28c660c63b792dea as Tooltip, $019364e6919ef1db$export$8c610744efcf8a1d as TooltipTrigger};
//# sourceMappingURL=module.js.map
